import { useQuery } from "@tanstack/react-query";
import { getApiInstance } from "@/utils/api";

export type NearpayReceipt = {
  id: string;
  url: string;
  status: string;
  amount_authorized: string;
};

export type NearpayTransaction = {
  id: string;
  created_at: string;
  receipts: NearpayReceipt[];
  invoice: number | null;
};

export type NearpayListResponse = {
  status: boolean;
  message: string | null;
  results: NearpayTransaction[];
  pages?: { total: number; current: number };
};

/**
 * يجلب قائمة إيصالات Nearpay بترقيم (صفحات).
 * استخدمه في صفحة "إيصالات الدفع" مع تمرير رقم الصفحة.
 */
export function useNearpayReceipts(page: number) {
  return useQuery<NearpayListResponse>({
    queryKey: ["nearpay-receipts", page],
    queryFn: async () => {
      const api = getApiInstance();
      const { data } = await api.get(
        `/store/invoices/get_all_transaction_from_nearpay/`,
        { params: { page } }
      );
      return data as NearpayListResponse;
    },
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
